(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Routes, Route } from "react-router";
import cx from "classnames";
import { I18nextProvider } from "react-i18next";
import { useDispatch, useSelector } from "../../store";
import i18next from "../Translation/configs/i18n";
import Page404 from "../../components/Page404";
import { SubscribeHistory } from "../BrowserHistory";
import { InitialSearchContainer, SearchContainer } from "../Search";
import ErrorBoundary from "../../components/ErrorBoundary";
import * as actions from "./state/actions";
import { configSelector } from "./state/selectors";
import styles from "./App.module.css";
import useUser from "../User/hooks";
import useLoadLanguage from "../Translation/hooks/useLoadLanguage";
import useLanguage from "../Translation/hooks/useLanguage";

const App = _ref => {
  let {
    apiUrl,
    basicUrl,
    logoSrc,
    countryCode,
    colors,
    className,
    lng,
    onChangeCountry,
    onProvideFeedback,
    onApplyCode,
    isDeclare,
    onBackAction,
    onShowError
  } = _ref;
  const dispatch = useDispatch();
  const config = useSelector(configSelector); // TODO test for build

  const [user] = useUser();
  useEffect(() => {
    dispatch(actions.initConfig({
      apiUrl,
      basicUrl,
      logoSrc,
      countryCode,
      colors,
      onChangeCountry,
      onProvideFeedback,
      onApplyCode,
      onBackAction,
      isDeclare,
      onShowError
    })); // eslint-disable-next-line
  }, []);
  useLoadLanguage(lng);
  const {
    language
  } = useLanguage();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.searhEngineApp, className)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    logoSrc: logoSrc,
    basicUrl: basicUrl
  }, /*#__PURE__*/React.createElement(SubscribeHistory, null), /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18next
  }, config && user.id && language && /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    index: true,
    element: /*#__PURE__*/React.createElement(InitialSearchContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "search/*",
    element: /*#__PURE__*/React.createElement(SearchContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    element: Page404
  })))));
};

__signature__(App, "useDispatch{dispatch}\nuseSelector{config}\nuseUser{[user]}\nuseEffect{}\nuseLoadLanguage{}\nuseLanguage{{ language }}", () => [useDispatch, useSelector, useUser, useLoadLanguage, useLanguage]);

App.propTypes = {
  className: PropTypes.string,
  apiUrl: PropTypes.string.isRequired,
  basicUrl: PropTypes.string,
  logoSrc: PropTypes.string,
  countryCode: PropTypes.oneOf(["bj", "ng", "et", "eu", "aj", "bh", "cg", "gn", "jo", "np", "ad", "am", "bd"]),
  colors: PropTypes.shape({
    info: PropTypes.string,
    success: PropTypes.string,
    secondary: PropTypes.string
  }),
  lng: PropTypes.string,
  onChangeCountry: PropTypes.func,
  onApplyCode: PropTypes.func,
  onProvideFeedback: PropTypes.func,
  onBackAction: PropTypes.func,
  onShowError: PropTypes.func,
  isDeclare: PropTypes.bool
};
App.defaultProps = {
  basicUrl: "",
  className: null,
  logoSrc: null,
  countryCode: null,
  colors: {
    info: "#404b6c",
    // used for heading code
    success: "#00bea6",
    // used for selected code
    secondary: "#8f93af" // used for code

  },
  lng: "en",
  onChangeCountry: () => {},
  onApplyCode: null,
  isDeclare: false,
  onBackAction: null,
  onProvideFeedback: () => {},
  onShowError: null
};

const _default = /*#__PURE__*/React.memo(App);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(App, "App", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/App/App.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/App/App.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();